module.exports = "<div class=\"assign-vhcle-popup-wrapper\">\n\n  <lfwms-result-data-table \n  (buttonActionHandler)=\"handleButtonAction($event)\" \n [tableMode] = \"tableMode\"\n[searchService]=\"assignVehicleSearchService\">\n</lfwms-result-data-table>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.html
// module id = ../../../../../src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.html
// module chunks = main